import { render, staticRenderFns } from "./block-vehicle.vue?vue&type=template&id=70e0706a&scoped=true&"
import script from "./block-vehicle.vue?vue&type=script&lang=js&"
export * from "./block-vehicle.vue?vue&type=script&lang=js&"
import style0 from "./block-vehicle.vue?vue&type=style&index=0&id=70e0706a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e0706a",
  null
  
)

export default component.exports